export const modalReducer = (state: any = false, action: any) => {
  switch (action.type) {
    case "MODAL": {
      return action.payload;
    }
    default:
      return state;
  }
};
export const alertModalReducer = (state: any = false, action: any) => {
  switch (action.type) {
    case "ALERT_MODAL": {
      return action.payload;
    }
    default:
      return state;
  }
};

export const StatusAlertReducer = (state: any = false, action: any) => {
  switch (action.type) {
    case "STATUS_ALERT": {
      return action.payload;
    }
    default:
      return state;
  }
};

export const alertReducer = (state: any = false, action: any) => {
  switch (action.type) {
    case "ALERT": {
      return action.payload;
    }
    default:
      return state;
  }
};

export const loaderReducer = (state = false, action: any) => {
  switch (action.type) {
    case "LOADING": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const internalLoaderReducer = (state = false, action: any) => {
  switch (action.type) {
    case "INTERNAL_LOADER": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const menuReducer = (state = "d-md-inline-block", action: any) => {
  switch (action.type) {
    case "TOGGLE_MENU": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const navBarReducer = (state = false, action: any) => {
  switch (action.type) {
    case "TOGGLE_NAVBAR": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const dashboardReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "DASHBOARD": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const agentReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "AGENTS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const agentDetailsReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "AGENT_DETAILS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const requestReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "REQUESTS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const statesReducer = (state = [], action: any) => {
  switch (action.type) {
    case "STATES": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const areasReducer = (state = [], action: any) => {
  switch (action.type) {
    case "AREAS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const transactionReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "TRANSACTIONS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const transactionDetailsReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "TRANSACTION_DETAILS": {
      console.log(action);
      // console.log(action)
      return action.payload;
    }

    default:
      return state;
  }
};

export const fileReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "FILE_UPLOAD": {
      return action.payload;
    }
    default:
      return state;
  }
};

export const cashoutReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "CASHOUT": {
      return action.payload;
    }
    default:
      return state;
  }
};

export const commissionReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "COMMISSIONS": {
      return action.payload;
    }
    default:
      return state;
  }
};

export const customersReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "CUSTOMERS": {
      return action.payload;
    }
    case "CUSTOMER": {
      return action.payload;
    }
    default:
      return state;
  }
};
export const tellersReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "TELLERS": {
      return action.payload;
    }
    case "TELLER": {
      return action.payload;
    }
    default:
      return state;
  }
};

export const terminalReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "TERMINALS": {
      return action.payload;
    }
    case "TERMINAL": {
      return action.payload;
    }
    default:
      return state;
  }
};
export const posAggregatorTransactionReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "POS_AGGREGATOR_TRANSACTION": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const logsReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "LOGS": {
      return action.payload;
    }
    case "LOG": {
      return action.payload;
    }
    default:
      return state;
  }
};
export const logsDetailsReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "LOGS_DETAILS": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const getTradePartnerLocation = (state = {}, action: any) => {
  switch (action.type) {
    case "Trade_Partner_Location": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const transactionTypeReducer = (state = [], action: any) => {
  switch (action.type) {
    case "TRANSACTION_TYPES": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const accountReducer = (state = [], action: any) => {
  switch (action.type) {
    case "ACCOUNTS": {
      return action.payload;
    }
    default:
      return state;
  }
};

export const notificationReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "NOTIFICATION": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const posTransactionsReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "POS_TRANSACTIONS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const salesReducer = (state = [], action: any) => {
  switch (action.type) {
    case "SALES_REP": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const complaintDashboardReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "COMPLAINT_DASHBOARD": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const agentDashboardReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "AGENT_DASHBOARD": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const agentActivityChartReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "AGENT_DASHBOARD_ACTIVITY_CHART": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const earningDashboardReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "EARNING_DASHBOARD": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const agentComissionEarningDashboardReducer = (
  state = {},
  action: any
) => {
  switch (action.type) {
    case "AGENT_COMMISSION_EARNING_DASHBOARD": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const agentTergetByIdDashboardReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "GET_AGENT_TARGETBYID": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const agentTransactionByIdDashboardReducer = (
  state = {},
  action: any
) => {
  switch (action.type) {
    case "GET_AGENT_TRANSACTIONBYID": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const agentCustomersByIdDashboardReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "GET_AGENT_CUSTOMERSBYID": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const transactionDashboardReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "TRANSACTION_DASHBOARD": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const transactionDashboardCountReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "TRANSACTION_COUNT": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const getPerformanceAndCommissionsReducer = (
  state = {},
  action: any
) => {
  switch (action.type) {
    case "GET_PERFORMANCE_AND_COMMISSION": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const bottomAgentRankReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "BOTTOM_AGENT_PERFORMANCE": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const analysisUpdateReducer = (state = [], action: any) => {
  switch (action.type) {
    case "DASHBOARD_ANALYTICS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const transactionCountDashboardSummaryReducer = (
  state = {},
  action: any
) => {
  switch (action.type) {
    case "TRANSACTION_DASHBOARD_COUNT": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const requestDashboardReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "REQUEST_DASHBOARD": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const closeSideBarReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "CLOSE_NAVIGATION": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const transactionDetailsStatusReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "TRANSACTION_DETAILS_STATUS": {
      return action.payload.message;
    }

    default:
      return state;
  }
};
export const transactionDetailsMessageReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "TRANSACTION_DETAILS_MESSAGE": {
      return action.payload.message;
    }

    default:
      return state;
  }
};
export const targetReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "TRANSACTION_TARGET": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const coordinatorReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "COORDINATORS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const coordinatorDetailsReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "COORDINATOR_DETAILS": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const aggregatorReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "AGGREGATORS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const aggregatorDetailsReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "AGGREGATOR_DETAILS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const userTypeReducer = (state = "", action: any) => {
  switch (action.type) {
    case "USER_TYPE": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const coordinatorTypeReducer = (state = "", action: any) => {
  switch (action.type) {
    case "COORDINATOR_TYPE": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const target = (state = "", action: any) => {
  switch (action.type) {
    case "PERFORMANCE_TARGET": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const bankReducer = (state = [], action: any) => {
  switch (action.type) {
    case "GET_BANKS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const genericReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "GENERIC_DATA": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const financeTableReducer = (state = [], action: any) => {
  switch (action.type) {
    case "FINANCE_TABLE_DATA": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const recAndDeclineReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "REC_STATUS": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const recAndDeclineMessageReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "SEND_REC_AND_DECLINED_MESSAGE": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const floatFinanceDetails = (state = {}, action: any) => {
  switch (action.type) {
    case "FLOAT_FINANCE_DETAILS": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const recAndDecSuccessMessage = (state = {}, action: any) => {
  switch (action.type) {
    case "REC_AND_DEC_MESSAGE_STATUS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const daysCountReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "GET_DAYS_FILTER": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const agentsPerformanceReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "AGENTS_PERFORMANCE": {
      return action.payload;
    }

    default:
      return state;
  }
};
export const getAllAgentReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "GET_ALL_AGENTS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getAggregatorPerformanceReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "AGGREGATOR_PERFORMANCE_LIST": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getBillTypeReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "BILL_TYPE": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getRegionsReducer = (state = [], action: any) => {
  switch (action.type) {
    case "REGIONS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getAggregatorCountReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "AGGREGATOR_COUNT": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getAssignedReducer = (state = [], action: any) => {
  switch (action.type) {
    case "ASSIGNED_TERMINALS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const PutMutipleAssignReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "SEND_TO_RETRIEVE_MULTIPLE_TERMINAL": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getUnAssignReducer = (state = [], action: any) => {
  switch (action.type) {
    case "UNASSIGNED_TERMINALS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getUnAssignMessageReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "ASSIGN_MULTIPLE_UNASSIGN_TERMINAL": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getaggregatorPhoneNumberReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "AGGREGATOR_BY_PHONE_NUMBER": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const administratorReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "ADMINISTRATORS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const singleAdminReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "SINGLE_ADMINISTRATOR": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const superAggregatorAggregatorReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "SUPER_AGGREGATOR_AGGREGATORS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getStartedAndStoppedTerminalsReducer = (
  state = {},
  action: any
) => {
  switch (action.type) {
    case "STARTEDSTOPPEDTERMINALS": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getAchievementReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "ACHIEVEMENT_DATA": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getLocationReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "LOCATION_PERFORMANCE_LIST": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getAggregatorByIdReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "GET_AGGREGATOR": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getFormStateReducer = (state = [], action: any) => {
  switch (action.type) {
    case "FORM_STATE": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getLGAReducer = (state = [], action: any) => {
  switch (action.type) {
    case "GET_LGA": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getAgentPerformanceDashboardReducer = (
  state = {},
  action: any
) => {
  switch (action.type) {
    case "GET_AGENT_PERFORMANCE_DASHBOARD": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getAggregatorPerformanceDashboardReducer = (
  state = {},
  action: any
) => {
  switch (action.type) {
    case "GET_AGGREGATOR_PERFORMANCE_DASHBOARD": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getPosMetricsDashboardReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "GET_POS_METRICS_DASHBOARD": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getCommissionEarningFilterDashboardReducer = (
  state = {},
  action: any
) => {
  switch (action.type) {
    case "GET_EARNING_COMMISSION_DASHBOARD": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const getFloatBalanceDashboardReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "GET_Float_METRICS_DASHBOARD": {
      return action.payload;
    }

    default:
      return state;
  }
};

export const otpReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "OTP": {
      return action.payload;
    }
    default:
      return state;
  }
};
export const verifyOtpReducer = (state = {}, action: any) => {
  switch (action.type) {
    case "VERIFYOTP": {
      return action.payload;
    }
    default:
      return state;
  }
};